import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { translateText } from '../utils/helpers';

class SearchTicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      focusOnSearch: false,
      displaySearchResult: false,
      selectedIndex: -1,
      selectedCategory: 0,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentDidUpdate(prevProps, prevState) {
    const { displaySearchResult } = this.state;
    if (!prevState.displaySearchResult && displaySearchResult) {
      this.scrollToTop();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('resize', this.handleWindowResize);
  }

  scrollToTop = () => {
    this.setState({ selectedIndex: -1, selectedCategory: 0 });
    if (this.container) {
      this.container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  handleKeyDown = (e) => {
    const { results, customResultSelect, featureAction } = this.props;
    const { selectedIndex, selectedCategory } = this.state;
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.scrollContainerBy(-20);
      if (selectedIndex > 0) {
        this.setState({ selectedIndex: selectedIndex - 1 });
      } else if (selectedCategory > 0) {
        const previousCategory =
          results[Object.keys(results)[selectedCategory - 1]];
        this.setState({
          selectedIndex: previousCategory.results.length - 1,
          selectedCategory: selectedCategory - 1,
        });
      }
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.scrollContainerBy(20);
      const currentCategory = results[Object.keys(results)[selectedCategory]];
      if (selectedIndex < currentCategory.results.length - 1) {
        this.setState({ selectedIndex: selectedIndex + 1 });
      } else if (selectedCategory < Object.keys(results).length - 1) {
        this.setState({
          selectedIndex: 0,
          selectedCategory: selectedCategory + 1,
        });
      }
    } else if (e.key === 'Enter' && selectedIndex >= 0) {
      e.preventDefault();
      const selectedItem =
        results[Object.keys(results)[selectedCategory]].results[selectedIndex];
      this.resetSearch();
      if (featureAction) {
        this.handleResultSelect(selectedItem.title);
        this.handleBlur();
      } else {
        customResultSelect(selectedItem.title);
        this.handleBlur();
      }
    }
  };

  handleResultSelect = (title) => {
    const { dispatch, featureAction, updateDisplaySearchResult } = this.props;
    updateDisplaySearchResult(false);

    return dispatch(featureAction.add(title));
  };

  datasetKeyProvider = () => btoa(Math.random()).substring(0, 12);

  handleSearchChange = (value) => {
    const { dispatch, featureAction, types, currency } = this.props;

    return (
      !!value.trim() &&
      dispatch(
        featureAction.search(window.encodeURIComponent(value), types, currency)
      )
    );
  };

  handleBlur = () => {
    const { updateDisplaySearchResult } = this.props;

    updateDisplaySearchResult(false);
    this.setState({
      focusOnSearch: false,
      displaySearchResult: false,
      selectedIndex: -1,
      selectedCategory: 0,
    });
  };

  handleChange = (e) => {
    const { updateDisplaySearchResult } = this.props;
    const { value } = e.target;
    updateDisplaySearchResult(true);

    this.setState({
      selectedIndex: -1,
      selectedCategory: 0,
      value,
      focusOnSearch: true,
      displaySearchResult: true,
    });

    return this.handleSearchChange(value);
  };

  handleCustomSearchChange = (e) => {
    const { customSearchChange, updateDisplaySearchResult } = this.props;
    const { value } = e.target;
    updateDisplaySearchResult(true);
    this.setState({
      selectedIndex: -1,
      selectedCategory: 0,
      focusOnSearch: true,
      displaySearchResult: true,
      value,
    });

    return customSearchChange(value);
  };

  resetSearch = () => {
    this.setState({
      value: '',
      focusOnSearch: true,
      displaySearchResult: true,
      selectedIndex: -1,
      selectedCategory: 0,
    });
  };

  scrollContainerBy(distance) {
    this.container.scrollBy({ top: distance, behavior: 'smooth' });
  }

  renderSearchResult = (results) => {
    const {
      featureAction,
      customResultSelect,
      globe,
      updateDisplaySearchResult,
    } = this.props;
    const { value, displaySearchResult, selectedCategory, selectedIndex } =
      this.state;
    const shortenDescription = (title, description, price) => {
      title = title || '';
      description = description || '';
      price = price || '';
      const totalLength = title.length + description.length + price.length;

      return totalLength > 76
        ? `${description.substring(0, 65)}...`
        : description;
    };
    const renderCategoryItems = (list, categoryIndex) =>
      list.map((item, index) => {
        const isSelected =
          selectedCategory === categoryIndex && selectedIndex === index;
        const shortDescription = shortenDescription(
          item.title,
          item.description,
          item.price
        );

        return shortDescription === item.description ? (
          <div
            className={`result${isSelected ? ' selected' : ''}`}
            key={item.title}
            onMouseDown={() => {
              this.resetSearch();
              if (featureAction) {
                this.handleResultSelect(item.title);
              } else {
                updateDisplaySearchResult(false);
                customResultSelect(item.title);
              }
            }}
            onMouseEnter={() => {
              this.setState({
                selectedIndex: index,
                selectedCategory: categoryIndex,
              });
            }}
            style={
              isSelected
                ? selectedItemStyle
                : window.innerWidth >= 700
                ? { marginLeft: '130px' }
                : { marginLeft: '0' }
            }
          >
            <div className="content">
              <div className="price">{item.price}</div>
              <div className="title">{item.title}</div>
              <div className="description">{item.description}</div>
            </div>
          </div>
        ) : (
          <div
            className={`results ${globe ? 'globe' : ''}`}
            key={this.datasetKeyProvider()}
            ref={(node) => {
              this.container = node;
            }}
          >
            <Popup
              key={item.title}
              trigger={
                <div
                  className="result"
                  onMouseDown={() => {
                    this.resetSearch();
                    if (featureAction) {
                      this.handleResultSelect(item.title);
                    } else {
                      customResultSelect(item.title);
                    }
                  }}
                  style={
                    isSelected
                      ? selectedItemStyle
                      : window.innerWidth >= 700
                      ? { marginLeft: '130px' }
                      : { marginLeft: '0' }
                  }
                >
                  <div className="content">
                    <div className="price">{item.price}</div>
                    <div className="title">{item.title}</div>
                    <div className="description">
                      {shortenDescription(
                        item.title,
                        item.description,
                        item.price
                      )}
                    </div>
                  </div>
                </div>
              }
              position="top center"
              wide
            >
              {item.description}
            </Popup>
          </div>
        );
      });

    return (
      <div
        className={`results transition ${
          value.length && displaySearchResult ? 'visible' : ''
        } ${globe ? 'globe' : ''}`}
        ref={(node) => {
          this.container = node;
        }}
      >
        {Object.keys(results).length ? (
          Object.keys(results).map((category, categoryIndex) => (
            <div
              className={window.innerWidth <= 700 ? '' : 'category'}
              key={category}
            >
              <div
                className="name"
                style={{
                  width: '130px',
                  padding: '0.85em 1em',
                  display: window.innerWidth <= 700 ? 'none' : 'block',
                }}
              >
                {category}
              </div>
              {renderCategoryItems(results[category].results, categoryIndex)}
            </div>
          ))
        ) : (
          <div className="message empty">
            <div className="header">No results found.</div>
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      loading,
      results,
      placeholder,
      featureAction,
      setMargin,
      correlationData,
      handleDeletion,
      hasReachedLimit,
      handleFiveLimit,
      globe,
      french,
      disabled,
    } = this.props;
    const { focusOnSearch, value } = this.state;

    return (
      <div
        className={`ui category search ${
          focusOnSearch && loading ? 'loading' : ''
        }`}
        style={{
          display: 'inline-block',
          textAlign: 'left',
          margin: setMargin ? '0.7rem' : '0',
        }}
      >
        <div className="ui icon input">
          <input
            style={{ borderRadius: globe && '0' }}
            type="text"
            name="ticker"
            placeholder={
              placeholder || translateText('Search for ticker or name', french)
            }
            value={value}
            tabIndex="0"
            className="prompt"
            autoComplete="off"
            onChange={
              featureAction ? this.handleChange : this.handleCustomSearchChange
            }
            onFocus={() => {
              // this.resetSearch();
              if (featureAction) {
                if (value) this.handleChange({ target: { value } });
              } else if (value)
                this.handleCustomSearchChange({
                  target: { value },
                });
              if (hasReachedLimit) {
                handleFiveLimit();
              }
              if (
                correlationData &&
                correlationData.excluded &&
                !!Object.keys(correlationData.excluded).length > 0
              ) {
                handleDeletion(Object.keys(correlationData.excluded)[0]);
              }
            }}
            onBlur={() => {
              // this.resetSearch();
              this.handleBlur();
            }}
            disabled={disabled}
          />
          <i aria-hidden="true" className="search icon" />
        </div>
        {this.renderSearchResult(results)}
      </div>
    );
  }
}

SearchTicker.propTypes = {
  loading: PropTypes.bool,
  results: PropTypes.array,
  dispatch: PropTypes.func,
  featureAction: PropTypes.object,
  placeholder: PropTypes.string,
  customSearchChange: PropTypes.func,
  customResultSelect: PropTypes.func,
  setMargin: PropTypes.bool,
  correlationData: PropTypes.object,
  handleDeletion: PropTypes.func,
  handleFiveLimit: PropTypes.func,
  hasReachedLimit: PropTypes.bool,
  globe: PropTypes.bool,
  updateDisplaySearchResult: PropTypes.func,
  french: PropTypes.bool,
  types: PropTypes.array,
  disabled: PropTypes.bool,
  currency: PropTypes.string,
};

SearchTicker.defaultProps = {
  loading: false,
  results: [],
  dispatch: () => false,
  customSearchChange: () => false,
  customResultSelect: () => false,
  featureAction: null,
  placeholder: '',
  setMargin: false,
  correlationData: {},
  handleDeletion: () => false,
  handleFiveLimit: () => false,
  hasReachedLimit: false,
  globe: false,
  updateDisplaySearchResult: () => false,
  french: false,
  types: [],
  disabled: false,
  currency: '',
};

const selectedItemStyle = {
  marginLeft: '130px',
  backgroundColor: '#f1f1f1',
};

export default connect((state) => ({
  user_region: state.Storage.user_region || 'CA',
}))(SearchTicker);
